import React, { useState, useContext, createContext, useRef } from 'react';
import Layout from "../../layout/Layout";
import { Row, Col, Spinner } from "reactstrap";
import Breadcrumbs from "../../global/Components/Breadcrumb/Breadcrumb";
import styles from './ProductPage.module.scss';
import SideBar from "../../global/Components/SideBar/SideBar";
import { useParams, useSearchParams } from "react-router-dom";
import Vendor from "../../global/Components/Vendor/Vendor";
import Carousel from '../../global/Components/Items/Carousel/Carousel';
import Product from '../../global/Components/Items/Product/Product';
import { showMsg } from '../../global/langs/langs';
import { UserContext } from '../../global/globalContext/context';
import { getRequest } from '../../global/utils/apiCall';
import { useEffect } from 'react';
import TitleSection from './Sections/TitleSection';
import ProductSection from './Sections/ProductSection';
import GallerySection from './Sections/GallerySection';
import useApiPrivate from '../../global/utils/hooks/useApiPrivate';
import useAuth from '../../global/utils/hooks/useAuth';
import AdvertiseBox from '../../global/Components/Advertise/AdvertiseBox';
import TabItem from '../../global/Components/Tab/TabItem/TabItem';
import TabContents from '../../global/Components/Tab/TabContent/TabContents';
import MoreDetails from './Sections/MoreDetails';
import ProductFeatures from './Sections/ProductFeatures';
import CommentsSection from './Sections/CommentsSection';
import SEO from '../../global/Components/SEO/SEO';
import { Toast } from 'primereact/toast';
import CustomBreadrumbs from '../../global/Components/Breadcrumb/CustomBreadrumbs';

const PRODUCTS_URL = 'api/v1/products/';
const COMMENTS_URL = 'api/v1/comments/';

export default function ProductPage() {
  const { id } = useParams();
  // const[searchParams, setSearchParams] = useSearchParams();
  const apiPrivate = useApiPrivate();
  const {auth} = useAuth();
  const toast = useRef(null);

  const [product, setProduct] = useState();
  const [relatedProducts, setRelatedProducts] = useState();
  const [user, setUser] = useState();
  const [comments, setComments] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState();
  const [activeTab, setActiveTab] = useState(0);


  const { lang } = useContext(UserContext);
  const commentContext = createContext();

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const callProduct = async () => {
    setIsLoading(true);
    
    try {
      const response = await getRequest(`${PRODUCTS_URL}${id}`,{
        params:{
          seller: 0,
        }
      });
      setProduct(response.data.data);
      setUser(response.data.data.user);
      callCategoryProducts(response.data.data.category.id, id, 8);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
    }  
      setIsLoading(false);
    }
    finally {
      setIsLoading(false);
    }
  }

  const callCategoryProducts = async (id, productId, limit = 8) => {
    setIsLoading(true);

    try {
      const response = await getRequest(PRODUCTS_URL,{
          params: {
            category_id: id,
            is_feature: 1, 
            limit: limit,
            is_discount: '',
            ignore: productId,
          }
      });
      setRelatedProducts(response.data.data);
      setIsLoading(false);
    } 
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      }  
      setIsLoading(false);
  }
    finally{
      setIsLoading(false);
    }
  }

  const callProductComment = async () => {
    setIsLoading(true);

    try{
      const response = await apiPrivate.get(`${COMMENTS_URL}${id}`,{
        params:{
          limit:'',
          page: currentPage && currentPage,
        }
      });
      setComments(response.data.data);
      setMetaData(response.data?.meta);
      setCurrentPage(response.data?.meta?.current_page);
      setIsLoading(false);
    }
    catch (error){
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      }
      setIsLoading(false);  
    }
    finally{
      setIsLoading(false);
    }
  }

  const addToRecentlyView = (id) => {
    let recentViewProducts = localStorage.getItem('recentProducts');
    recentViewProducts = recentViewProducts ? JSON.parse(recentViewProducts) : [];

    if(!recentViewProducts.includes(parseInt(id))) {
      recentViewProducts.unshift(parseInt(id));
      localStorage.setItem('recentProducts', JSON.stringify(recentViewProducts?.slice(0,8)));
    }
  }

  const getRecentViewProducts = () => {
    let recentViewProducts = localStorage.getItem('recentProducts');

    if (recentViewProducts) {
      recentViewProducts = JSON.parse(recentViewProducts);
    }
  }


  const handleTabClick = (tabId) => {
      setActiveTab(tabId);
    };

  useEffect(() => {
    if(product && product.properties.length > 0) {
      setActiveTab('product-features');
      return
    } else if(product && product.description) {
        setActiveTab('more-details');
        return
    } else {
        setActiveTab('comments');
    }
  },[product]);

  useEffect(() => {
    getRecentViewProducts()
  }, []);


  useEffect(() => {
    callProduct();
    callProductComment();
  },[]);

  useEffect(() => {
    callProduct();
    callProductComment();
    addToRecentlyView(id);
  },[id]);

  useEffect(() => {
    callProductComment();
    // currentPage &&
    //   searchParams.set('page', currentPage);
    //   setSearchParams(searchParams);
  },[currentPage]);

  return (
    <product-component>
      <SEO title={product && `${product.title}` } />
      <Toast ref={toast} position="top-center" />

      <Layout>
          <div className={`mb-3 container-xxl`}>
            <Row className={`pt-5 pb-1`}>
              <Col>
                <CustomBreadrumbs id={product && product.category.id} title={product && product.category.title} />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={9}>
                <div className={`bg-white p-4 mb-3 ${styles.lgtBackground}`}>
                  <Row>
                    <Col sm={12} xl={5} className={`mb-3`}>
                    { isLoading 
                      ? (
                          <>
                              <Spinner color='primary' className='mx-auto'>
                                Loading...
                              </Spinner>
                          </>
                          ) 
                      : (
                        product
                          ? (
                            <GallerySection product={product} />
                            ) 
                            : (
                              <img src='/images.png' />
                          )
                        )
                    }    
                    </Col>
                    <Col sm={12} xl={7} className={`${styles.productInfo}`}>
                      {
                        isLoading 
                          ? (
                            <>
                              <Spinner color='primary' className='mx-auto'>
                                Loading...
                              </Spinner>
                            </>
                          ) 
                          : (
                            product &&
                            <ProductSection product={product} handleUpdateProduct={callProduct} />
                          )
                      }
                    </Col>
                </Row>
              </div>
                {
                  relatedProducts &&
                    <>
                      <div className="p-4 ps-0">
                        <TitleSection title={'related_products'} linkText={'show_all'} categoryId={product.category_id}   />
                      </div>
                      <div className={`bg-white p-4 mb-3 ${styles.lgtBackground}`}>
                        <Row>
                          <Col>
                            <Carousel>
                              {
                                relatedProducts.map((item) => (
                                  <div className='ps-2' key={item.id}>
                                    <Product data={item} />
                                  </div>
                                ))
                              }
                            </Carousel>
                          </Col>
                        </Row>
                      </div>
                    </>
                }
                <div className={`bg-white p-4 mb-3 ${styles.lgtBackground}`}>
                  <Row>
                    <Col>
                    {        
                     product && comments && 
                      <>
                        <div className={`${styles.tabNav} sticky-top bg-white`}>
                        {
                          product.properties.length > 0 &&
                            <TabItem 
                              id={'product-features'} 
                              title={'Product Features'} 
                              icon={'bi bi-card-checklist me-2'} 
                              type={'product-features'} 
                              activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} 
                              handleTabClick={handleTabClick} />
                        }
                        {
                          product.description &&
                            <TabItem  
                              id={'more-details'} 
                              title={'More Details'} 
                              icon={'bi bi-card-text'} 
                              type={'more-details'} 
                              activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} 
                              handleTabClick={handleTabClick} />
                        }
                          <TabItem  
                            id={'comments'} 
                            title={'Ask From the Seller'} 
                            icon={'bi bi-chat-left-text'} 
                            type={'comments'} 
                            activeTab={activeTab} setActiveTab={(e) => setActiveTab(e.target.id)} 
                            handleTabClick={handleTabClick} />
                        </div>
                        <div className={`pt-4`}>
                          <TabContents>
                            {
                              activeTab === 'product-features' && <ProductFeatures features={product.properties} />
                            }
                            {
                              activeTab === 'more-details' && <MoreDetails description={product.description} />
                            }
                            {
                              activeTab === 'comments' && 
                                <commentContext.Provider value={{comments,setComments}}>
                                  <CommentsSection 
                                    comments={comments}
                                    productOwnerId={user.id}
                                    onCallProductComment={callProductComment}
                                    metaData={metaData}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage} 
                                    />
                                </commentContext.Provider>
                            }
                          </TabContents>
                        </div>
                      </>
                      }
                    </Col>
                  </Row>
                </div>
              </Col>
              <SideBar xs={12} sm={12} md={12} lg={3}>
                { user && auth &&
                    user.id === auth?.userInfo?.user?.id &&
                      <AdvertiseBox />
                }
                {
                  user &&
                    <Vendor user={user}/>
                }
              </SideBar>
            </Row>
          </div>
        </Layout>
  </product-component>
  )
}
